import { CRUDButtons } from 'components/CRUDButtons';
import { Alignment, Column, ColumnType } from 'components/Table/types/column';
import { FormattedNumberCell } from 'routes/Risk/components/FormattedNumberCell';
import { NestedRow } from 'routes/Risk/components/HierarchyCell';
import { CreditLimitsTableRow } from 'types/risk';

interface CreditLimitsColumnsConfig {
  readonly canEdit: boolean;
}

export const createCreditLimitsColumns = ({
  canEdit,
}: CreditLimitsColumnsConfig): Array<Column<CreditLimitsTableRow>> => [
  {
    minWidth: 48,
    weight: 0.0001,
    columnType: ColumnType.custom,
    key: 'id',
    filterable: false,
    header: '',
    textuallyOverlap(value: any, keyword: string): boolean {
      return value.includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return v1.localeCompare(v2);
    },
    component: (props) => <CRUDButtons {...props} showDelete={false} disableEdit={!canEdit} />,
  },
  {
    key: 'account',
    columnType: ColumnType.custom,
    header: 'Account',
    weight: 1,
    alignment: Alignment.left,
    editable: false,
    filterable: true,
    sortingDifference(v1: string, v2: string): number {
      return v1.localeCompare(v2);
    },
    textuallyOverlap(value: string, keyword: string): boolean {
      return value.includes(keyword);
    },
    component: (props) => <NestedRow account={props} limitType="credit" />,
  },
  {
    key: 'buying_power',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Buying Power',
    editable: false,
    filterable: true,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return value.includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return v1.localeCompare(v2);
    },
  },
  {
    key: 'consumed',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Consumed',
    editable: false,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
  {
    key: 'threshold_level_first',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Warning Level 1',
    editable: false,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
  {
    key: 'threshold_level_second',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Warning Level 2',
    editable: false,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
  {
    key: 'threshold_level_third',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Warning Level 3',
    editable: false,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
  {
    key: 'rejection_level',
    columnType: ColumnType.custom,
    alignment: Alignment.center,
    header: 'Rejection Level',
    editable: false,
    component: FormattedNumberCell,
    textuallyOverlap(value: any, keyword: string): boolean {
      return String(value).includes(keyword);
    },
    sortingDifference(v1: any, v2: any): number {
      return Number(v1) - Number(v2);
    },
  },
];
